const { Core, Utils } = Global;
const { $show } = Utils;
const LANGUAGE_COOKIE_NAME = "language";

customElements.define('localization-dropdown', class extends Core {
    elements = {
        $: ['spinner', 'select'],
        form: 'form'
    }

    render() {
        this.$('form', {
            change: this._onFormChange
        });
    }

    _onFormChange() {
        $show(this.$('spinner'));
        const localeCode = this.querySelector(':checked').value;
        const langCode = localeCode.split("-")[0];
        document.cookie = `${LANGUAGE_COOKIE_NAME}=${langCode};domain=.miniversos.pt;path=/`;
        this.$('form').submit();
    }
});
